import request from './service'
// 导出
export function exportExcel (data) {
  return request({
    url: `/v1/formData/export?yyid=${data.yyid}&taskId=${data.taskId}`,
    method: 'get'
  })
}
// 查询数据结果
export function getDataviewInfo (data) {
  return request({
    url: `/v1/formData/condition?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&yyid=${data.yyid}`,
    method: 'post',
    data: data.condition,
    headerType: 'forward'
  })
}
// 获取查询字段和排序字段
export function getFieldsByYYID (data) {
  return request({
    url: `/v1/formData/fields?yyid=${data}`,
    method: 'get'
  })
}
// 历史分享详情页
export function getresultCondition (data) {
  console.log(data.condition)
  return request({
    url: `/v1/formData/condition?pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&yyid=${data.yyid}`,
    method: 'post',
    data: data.condition,
    headerType: 'forward'
  })
}
